/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-handler-names */
import {Accordion, AccordionTab} from 'primereact/accordion';
import {Card} from 'primereact/card';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {Dropdown} from 'primereact/dropdown';
import {Ripple} from 'primereact/ripple';
import {classNames, ObjectUtils} from 'primereact/utils';
import { FilterService } from "primereact/api";
import PropTypes from 'prop-types';
import React from 'react';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import {PrintButtonComponent} from '../report/ReportUtils';
import BaseContainer from './BaseContainer';
import ProfileService from '../services/ProfileService';
import CustomDialog from '../components/CustomDialog';

class BaseListContainer extends BaseContainer {
    constructor(props, service) {
        super(props);
        this.service = service;
        this.user = this.authService.getProfile();
        this.actionTemplate = this.actionTemplate.bind(this);
        this.booleanTemplate = this.booleanTemplate.bind(this);
        this.handleGoToDetail = this.handleGoToDetail.bind(this);
        this.handleGoToNew = this.handleGoToNew.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePage = this.handlePage.bind(this);
        this.readCriteriaFromCookie = this.readCriteriaFromCookie.bind(this);
        this.readMessage = this.readMessage.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.renderDataTable = this.renderDataTable.bind(this);
        this.renderCriteria = this.renderCriteria.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
        this.prepareColumns = this.prepareColumns.bind(this);
        this.getList = this.getList.bind(this);
        this.renderView = this.renderView.bind(this);
        this.getCleanSearchCriteria = this.getCleanSearchCriteria.bind(this);
        this.getCleanSearchCriteriaPrototype = this.getCleanSearchCriteriaPrototype.bind(this);
        this.updateSearchCriteria = this.updateSearchCriteria.bind(this);
        this.updateSearchCriteriaPrototype = this.updateSearchCriteriaPrototype.bind(this);
        this.onAfterGetList = this.onAfterGetList.bind(this);
        this.handleChangeLimitObj = this.handleChangeLimitObj.bind(this);
        this.cleanSearchCriteria = this.cleanSearchCriteria.bind(this);
        this.handleOnSelectionChange = this.handleOnSelectionChange.bind(this);
        this.handleOnSelectAllChange = this.handleOnSelectAllChange.bind(this);
        this.getPageLinkSize = this.getPageLinkSize.bind(this);
        this.updateListElements = this.updateListElements.bind(this);
        this.defaultLoading = true;
        this.dataKey = this.getDataKey();
        if (service !== undefined && service !== null) {
            this.service.setUiMethods(this.blockUi, this.unblockUi);
        }
        this.labelHeader = this.labelHeader.bind(this);
        this.renderPrintButton = this.renderPrintButton.bind(this);
        this.profileService = new ProfileService();
        this.rowClassName = this.rowClassName.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.initializeFromBackend();
        if (this.defaultLoading) {
            this.readCriteriaFromCookie();
        }
        this.readMessage();
        this.checkIfDeviceAlreadyAddedToTrusted();
    }

    readCriteriaFromCookie() {
        const criteria =
            this.readCookie(this.getCriteriaName()) !== undefined &&
            this.readCookie(this.getCriteriaName()) != null &&
            !this.props.hideFilters
                ? this.updateSearchCriteriaPrototype(JSON.parse(this.readCookie(this.getCriteriaName())))
                : this.getCleanSearchCriteriaPrototype();
        this.removeCookie(this.getCriteriaName());
        if (this._isMounted) {
            criteria.maxResults = criteria.maxResults ? criteria.maxResults : 10;
            this.setState(
                {
                    loading: this.props.lazy,
                    criteria,
                    first: criteria.firstResult,
                },
                () => (!this.props.list ? this.refreshTable() : null)
            );
        }
    }

    refreshTable() {
        this.getList();
    }

    onAfterGetList(res) {}

    updateListElements(list) {
        return list;
    }

    renderPrintButton() {
        const {t} = this.props;
        return (
            <PrintButtonComponent
                key={`print-button${this.getListTitle()}`}
                reportFileNameBase={t(this.getListTitle())}
                generateReport={this.generateReport.bind(this)}
                disabled={!this.state.selectedList.length > 0}
            />
        );
    }

    checkIfDeviceAlreadyAddedToTrusted() {
        const { t } = this.props;
        if(this.readCookie('startAfterLoginCookie') === 'true' && !(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
        this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
        this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
        this.authService.getProfile().helpdeskUserRole === 'HOTLINE')){
            let currentDeviceIdent = this.authService.generateDeviceUuid();
            this.profileService.getTrustedDevices(this.user?.userAgreementMapId)
                .then((res) => {
                    if (res.trustedDeviceList.length > 0) {
                        if(res.trustedDeviceList.filter(d => d.deviceIdent === currentDeviceIdent).length > 0) {
                            console.log("Urzadzenie to jest na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: false });
                        }
                        else {
                            console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: true });
                        }
                    } else {console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                        this.setState({ addTrustedDeviceDialog: true });}
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                })
        }
       
    }

    handleAddToTrustedDevice() {
        let generatedDeviceUuid = this.authService.generateDeviceUuid();
        this.profileService
            .addTrustedDevice(generatedDeviceUuid, this.user?.userAgreementMapId)
            .then((res) => {
                if (res === true) {
                    this.showSuccessMessage("Dodano urządzenie do zaufanych");
                    this.saveCookie('startAfterLoginCookie', false);
                    this.setState({ addTrustedDeviceDialog: false });
                }
            })
            .catch(() => {
                this.showErrorMessage("Nie udało się dodać urządzenia do zaufanych");
            });
    }

    renderAddToTrustedDevicesDialog(){
        let startAfterLoginCookie = false;
        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') &&
            this.readCookie('startAfterLoginCookie') === 'true') {
            startAfterLoginCookie = true;
        }
        return  (
            this.state.addTrustedDeviceDialog && startAfterLoginCookie === true) && <CustomDialog
            name='add-trusted-dialog'
            className='add-trusted-device'
            header="Dodawanie urządzenia do zaufanych"
            visible={this.state.addTrustedDeviceDialog}
            viewMode={'VIEW'}
            onHide={() => {
                //  this.authService.logout();
                this.saveCookie('startAfterLoginCookie', false);
                this.setState({
                    addTrustedDeviceDialog: false,
                    //renderCodeVerificationPage: true
                    //user: undefined,
                });
            }}
            closeable
        >
            <div className='codeDialog-text'>
                <label>{"W przypadku dodania urządzenia do zaufanych podawanie kodu weryfikacyjnego przy kolejnych logowaniach nie będzie wymagane."} </label>
            </div>
            <div className='col-width-auto codeBtn'>
                <ActionButton
                    label={"Dodaj"}
                    variant='blue'
                    // className='edit-blue-link'
                    handleClick={() => this.handleAddToTrustedDevice()}
                    disabled={this.state.captchaPreventAction}
                />
            </div>

        </CustomDialog>
    }

    generateReport() {}
    getList() {
        const {criteria} = this.state;
        this.service
            .getList(criteria)
            .then((data) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: this.updateListElements(data.content),
                            loading: false,
                            size: data.totalElements,
                        },
                        () => this.onAfterGetList(data)
                    );
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: [],
                            loading: false,
                            size: 0,
                        },
                        () => {
                            this.afterGetListError();
                        }
                    );
                }
            });
    }

    afterGetListError() {
        this.showErrorMessage('Wystąpił błąd systemu. Nie udało się pobrać listy.', 10000);
    }

    getCleanSearchCriteria(selectAll) {
        return {
            firstResult: 0,
            maxResults: 10,
            maxResultsObj: {value: 10},
            sortField: 'id',
            sortAsc: true,
        };
    }

    getCleanSearchCriteriaPrototype() {
        const criteria = this.getCleanSearchCriteria();
        criteria.maxResultsObj = {value: criteria.maxResults};
        return criteria;
    }

    cleanSearchCriteria() {
        this.setState({criteria: this.getCleanSearchCriteriaPrototype()}, () => this.handleFormSubmit());
    }

    updateSearchCriteria(criteria) {
        return {
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            maxResultsObj: {value: criteria.maxResults},
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    updateSearchCriteriaPrototype(criteria) {
        criteria = this.updateSearchCriteria(criteria);
        criteria.maxResultsObj = {value: criteria.maxResults};
        return criteria;
    }

    getCriteriaName() {
        return 'list-sc';
    }

    initializeFromBackend() {}

    handleSort(event) {
        if (this._isMounted) {
            this.setState(
                (prevState) => ({
                    loading: this.props.lazy,
                    criteria: {
                        ...prevState.criteria,
                        sortField: event.sortField,
                        sortAsc: event.sortOrder > 0,
                    },
                }),
                () => (this.props.lazy ? this.refreshTable() : null)
            );
        }
    }

    handlePage(event) {
        if (this._isMounted) {
            this.setState(
                (prevState) => ({
                    loading: this.props.lazy,
                    first: event.first,
                    criteria: {
                        ...prevState.criteria,
                        firstResult: event.first,
                        maxResults: event.rows,
                        maxResultsObj: {value: event.rows},
                    },
                }),
                () => (this.props.lazy ? this.refreshTable() : null)
            );
        }
    }

    handleValidForm() {
        this.setState(
            (prevState) => ({
                blocking: false,
                loading: true,
                first: 0,
                criteria: {
                    ...prevState.criteria,
                    firstResult: 0,
                },
            }),
            () => (this.props.lazy ? this.refreshTable() : null)
        );
    }

    getContainerListName() {
        return 'list-container';
    }

    readMessage() {
        const messageFromStorage = this.readCookie(this.getContainerListName());
        if (messageFromStorage !== undefined && messageFromStorage != null) {
            const message = JSON.parse(messageFromStorage);
            this.removeCookie(this.getContainerListName());
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }

    handleGoToDetail(href, e) {
        e.preventDefault();
        this.blockUi();
        const {criteria} = this.state;
        if (!this.props.hideFilters) {
            this.saveCookie(this.getCriteriaName(), JSON.stringify(criteria));
        }
        window.location.href = href;
    }

    handleGoToNew(e) {
        e.preventDefault();
        this.blockUi();
        const {newUrl} = this.props;
        const {criteria} = this.state;
        if (!this.props.hideFilters) {
            this.saveCookie(this.getCriteriaName(), JSON.stringify(criteria));
        }
        window.location.href = newUrl;
    }

    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const href = `${detailUrl}/${rowData?.id}`;
        return (
            <ActionLink
                label={'Szczegóły'}
                handleClick={this.handleGoToDetail.bind(this, href)}
                variant='blue'
                className='p-link hover-underline'
                key={'view-button'}
                iconSize='xs'
                iconName='mdi-arrow-right'
                iconColor='blue'
            />
        );
    }

    booleanTemplate(field, rowData) {
        if (rowData && rowData[field] !== null && rowData[field] !== undefined && rowData[field] === true) {
            return 'TAK';
        } else return 'NIE';
    }

    addButton() {
        const {newUrl} = this.props;
        return <ActionButton label={'Dodaj'} handleClick={this.handleGoToDetail.bind(this, newUrl)} key={'add-button'} />;
    }

    handleChangeLimitObj(v) {
        this.setState(
            (prevState) => ({
                first: 0,
                criteria: {
                    ...prevState.criteria,
                    firstResult: 0,
                    maxResults: v.value,
                    maxResultsObj: {value: v.value},
                },
            }),
            () => (this.props.lazy ? this.refreshTable() : null)
        );
    }

    handleOnSelectionChange(e) {
        const filteredList = this.hasFilter() ? this.processData() : this.state.list;
        const selectedFilteredList = e.value.filter(item => 
            filteredList.some(filteredItem => filteredItem.petraId === item.petraId)
        );
        this.setState({
            selectedList: selectedFilteredList,
            selectAll: selectedFilteredList.length === Math.min(this.getTotalElements(), filteredList.length)
        });
    }

    handleOnSelectAllChange(e) {
        const selectAll = e.checked;
        if (selectAll) {
            if (this.props.lazy) {
                let allCriteria = {...this.state.criteria};
                allCriteria.firstResult = 0;
                allCriteria.maxResults = 2147483647;
                this.setState({loading: true});
                this.service
                    .getList(allCriteria)
                    .then((data) => {
                        if (this._isMounted) {
                            this.setState({
                                selectAll: true,
                                selectedList: this.getContentFromResponse(data),
                                loading: false,
                            });
                        }
                    })
                    .catch((err) => {
                        this.setState({loading: false});
                    });
            } else {
                this.setState({
                    selectAll: true,
                    selectedList: this.state.list,
                    loading: false,
                });
            }
        } else {
            this.setState({
                selectAll: false,
                selectedList: [],
                loading: false,
            });
        }
    }

    getContentFromResponse(response) {
        return response.content;
    }

    getTotalElements() {
        return this.state.size;
    }

    getListTitle() {
        return 'list.title';
    }

    getPageLinkSize() {
        let totalPages = this.state.size / this.state.criteria.maxResults;
        let currentPage = this.state.first / this.state.criteria.maxResults;
        if (totalPages <= 5) {
            return 5;
        } else if (totalPages === 6 || currentPage < 3 || currentPage >= totalPages - 3) {
            return 6;
        } else {
            return 7;
        }
    }

    getDataKey() {
        return 'id';
    }

    prepareHeaderItems() {
        return [{type: 'LABEL', className: 'float-right'}];
    }

    labelHeader(item, index) {
        return (
            <label id={'list-title'} className='list-title header-item' key={`list-title-${item}`}>
                {this.translate(this.getListTitle())}
            </label>
        );
    }

    globalFilterFields() {}

    hasFilter() {
        let filters = this.state.filters;
        return filters && Object.keys(filters).length > 0;
    }
    processData(localState) {
        let data = this.state.list;
        if(!this.props.lazy) {
            if(data && data.length) {
                let localFilters = (localState && localState.filters) || this.state.filters; 
                if (localFilters || this.props.globalFilter) {                 
                    data = this.filterLocal(data, localFilters);
                }
            }
        }
        return data;
    }


    filterLocal(value) {
        let filteredValue = [];
        let filters = this.state.filters;
        let columns = this.prepareColumns();
        for(let i = 0; i < value.length; i++) {
            let localMatch = true;
            let globalMatch = false;
            let filterMetaGlobal = filters ? filters['global'] : null;
            let globalFiltersFields = this.globalFilterFields();
            for(let j = 0; j < columns.length; j++) {
                let col = columns[j];
                let filterMeta = filters ? filters[col.field] : null;
                
                //local
                if(filterMeta) {
                    let filterValue = filterMeta.value;
                    let filterField = col.field;
                    let filterMatchMode = filterMeta.matchMode||col.props.filterMatchMode;
                    let dataFieldValue = ObjectUtils.resolveFieldData(value[i], filterField);
                    let filterConstraint = filterMatchMode === 'custom' ? col.props.filterApply : FilterService.filters[filterMatchMode];

                    if(!filterConstraint(dataFieldValue,filterValue)) {
                        localMatch = false;
                    }
                    if(!localMatch) {
                        break;
                    }
                }
                //global
                if(globalFiltersFields){
                    if(globalFiltersFields.includes(col.field) && !globalMatch && filterMetaGlobal)  {
                        let globalFilterConstraint = FilterService.filters['contains'];
                        globalMatch = globalFilterConstraint(ObjectUtils.resolveFieldData(value[i], col.field), filterMetaGlobal['value']);
                    }
                }
                
            }
            let matches = localMatch;
            if(filterMetaGlobal) {
                
                matches = localMatch&&globalMatch;
            }
            if(matches) {
                filteredValue.push(value[i]);
            }
        }
        if(filteredValue.length === value.length) {
            filteredValue = value;
        }
        
        return filteredValue;
    }

    renderDataTable(columns, list, size) {
        const {criteria, first, loading} = this.state;
        if (list === null || list === undefined) {
            list = this.props.list ? this.props.list : this.state.list;
        }
        if (size === null || size === undefined) {
            size = this.props.list ? this.props.size : this.state.size;
        }
        const dynamicColumns = columns.map((col) => {
            return (
                <Column
                    selectionMode={col.selectionMode}
                    key={col.key ? col.key : col.field}
                    field={col.field}
                    filter
                    filterField={col.field}
                    showFilterMenu={false}
                    header={col.header}
                    body={col.body}
                    bodyClassName={col.bodyClassName}
                    headerClassName={col.headerClassName}
                    className={col.className}
                    sortable={col.sortable}
                    sortField={col.sortField !== undefined ? col.sortField : col.field}
                    style={col.width !== undefined ? {width: col.width} : null}
                />
            );
        });
        const rowsPerPageOptions = [5, 10, 20, 50, 100];
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <div className='datatable-responsive'>
                        <DataTable
                            id='dataTable'
                            key='data-table'
                            emptyMessage={this.translate('list.empty')}
                            className='p-datatable-responsive'
                            breakpoint='10px'
                            value={list}
                            paginator
                            globalFilterFields={this.globalFilterFields()}
                            filters={this.state.filters}
                            // filterDisplay='row'
                            rows={criteria.maxResults}
                            totalRecords={size}
                            first={first}
                            rowsPerPageOptions={rowsPerPageOptions}
                            sortField={criteria.sortField}
                            sortOrder={criteria.sortAsc ? 1 : -1}
                            loading={loading}
                            paginatorPosition='bottom'
                            currentPageReportTemplate={
                                size !== 0
                                    ? `Pozycje od ${first + 1} do ${
                                          first + criteria.maxResults > size ? size : first + criteria.maxResults
                                      } z ${size} łącznie`
                                    : '0 pozycji'
                            }
                            paginatorTemplate={{
                                layout: 'RowsPerPageDropdown PrevPageLink PageLinks NextPageLink CurrentPageReport',
                                PrevPageLink: (options) => {
                                    if (criteria.firstResult === 0) {
                                        return null;
                                    } else {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={options.onClick}
                                                disabled={options.disabled}
                                            >
                                                <span className='p-paginator-icon pi pi-angle-left'></span>
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                                NextPageLink: (options) => {
                                    if (criteria.firstResult + criteria.maxResults >= size) {
                                        return null;
                                    } else {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={options.onClick}
                                                disabled={options.disabled}
                                            >
                                                <span className='p-paginator-icon pi pi-angle-right'></span>
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                                RowsPerPageDropdown: (options) => {
                                    return this.renderPagination(rowsPerPageOptions);
                                },
                                CurrentPageReport: (options) => {
                                    return <div className='p-paginator-dummy' />;
                                },
                                PageLinks: (options) => {
                                    if (options.view.startPage === options.page && options.view.startPage !== 0) {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={() => {
                                                    this.handlePage({first: 0, rows: this.state.criteria.maxResults});
                                                }}
                                            >
                                                {1}
                                                <Ripple />
                                            </button>
                                        );
                                    } else if (options.view.endPage === options.page && options.view.endPage !== options.totalPages - 1) {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={() => {
                                                    this.handlePage({
                                                        first: (options.totalPages - 1) * this.state.criteria.maxResults,
                                                        rows: this.state.criteria.maxResults,
                                                    });
                                                }}
                                            >
                                                {options.totalPages}
                                                <Ripple />
                                            </button>
                                        );
                                    } else if (
                                        (options.view.startPage + 1 === options.page && options.view.startPage !== 0) ||
                                        (options.view.endPage - 1 === options.page &&
                                            options.view.endPage !== options.totalPages - 1 &&
                                            options.page !== options.totalPages - 1)
                                    ) {
                                        const className = classNames(options.className, {'p-disabled': true});
                                        return (
                                            <span className={className} style={{userSelect: 'none'}}>
                                                ...
                                            </span>
                                        );
                                    } else {
                                        return (
                                            <button type='button' className={options.className} onClick={options.onClick}>
                                                {options.page + 1}
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                            }}
                            pageLinkSize={this.getPageLinkSize()}
                            lazy={this.props.lazy}
                            onPage={this.handlePage}
                            onSort={this.handleSort}
                            selectionMode={'checkbox'}
                            onSelectionChange={this.handleOnSelectionChange}
                            selection={this.state.selectedList}
                            selectAll={this.state.selectAll}
                            onSelectAllChange={this.handleOnSelectAllChange}
                            dataKey={this.dataKey}
                            expandedRows={this.state.expandedRows}
                            onRowToggle={this.handleOnRowToggle}
                            onRowExpand={this.handleOnRowExpand}
                            onRowCollapse={this.handleOnRowCollapse}
                            rowExpansionTemplate={this.rowExpansionTemplate}
                            rowClassName={this.rowClassName}
                            selectionPageOnly={false}
                        >
                            {this.props.rowExpansionTemplate ? <Column expander headerStyle={{width: '3em'}}></Column> : null}
                            {this.props.disableSelection === true || !this.props.selectionMode ? null : (
                                <Column selectionMode={this.props.selectionMode} headerStyle={{width: '3em'}}></Column>
                            )}
                            {dynamicColumns}
                        </DataTable>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }


    rowClassName(e){
        if(this.props.customDatatableRowStyle === true){
           return this.datatableRowColorTemplate(e);
        }  else {
            return this.props.rowClassName;
        } 
    }

    datatableRowColorTemplate(){}


    renderPagination(rowsPerPageOptions) {
        return (
            <div className='p-paginator-rows-per-page'>
                <Dropdown
                    aria-label={'Pokaż na stronie'}
                    key={'maxResults'}
                    id={'maxResults'}
                    inputId={'maxResults-input'}
                    name={'maxResults'}
                    emptyMessage={this.translate('list.emptyDropdown')}
                    //style={{ width: '100%' }}
                    value={this.state.criteria.maxResults}
                    options={rowsPerPageOptions}
                    onChange={(e) =>
                        this.setState(
                            (prevState) => ({
                                criteria: {
                                    ...prevState.criteria,
                                    maxResults: e.target.value,
                                },
                            }),
                            () => this.handleChangeLimitObj(e)
                        )
                    }
                    filter={false}
                    showClear={false}
                />
                <label id={'limit-label-id'} className='p-paginator-rows-per-page-label' htmlFor={'limit-input'}>
                    {this.translate('list.paginator')}
                </label>
            </div>
        );
    }

    prepareColumns() {
        return [];
    }

    renderCriteria() {
        return <DivContainer colClass='row' />;
    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleFormSubmit();
        }
    }

    renderFilter() {
        return !this.props.hideFilters ? (
            <Accordion className='filter-accordion' activeIndex={0}>
                <AccordionTab
                    header={
                        <React.Fragment>
                            <img className='card-icon' alt={this.translate('list.filter')} src={`/images/ico_filter.svg`} />
                            <span>{this.translate('list.filter')}</span>
                        </React.Fragment>
                    }
                >
                    <form
                        className='form-search-criteria'
                        onSubmit={(e) => {
                            this.handleFormSubmit(e);
                        }}
                        onKeyDown={(e) => this.onKeyDown(e)}
                        //avoid setting red border just after the page has loaded (red border because of undefined required value in FF)
                        noValidate
                    >
                        <DivContainer colClass='col-12'>
                            {this.renderCriteria()}
                            {/* <DivContainer colClass='row'>
                                                <DivContainer colClass='col-md-12'>
                                                    <ActionButton
                                                        className='float-right'
                                                        label='Filtruj'
                                                        handleClick={this.handleFormSubmit}
                                                    />
                                                    <ActionButton
                                                        className='float-right mr-2'
                                                        label='Wyczyść'
                                                        handleClick={this.cleanSearchCriteria}
                                                    />
                                                </DivContainer>
                                            </DivContainer> */}
                        </DivContainer>
                    </form>
                </AccordionTab>
            </Accordion>
        ) : null;
    }

    renderView() {
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <Card
                        className='list-card'
                        // header={this.renderHeader()}
                    >
                        <DivContainer colClass='row' rendered={this.props.hideFilters !== true}>
                            {this.renderFilter()}
                        </DivContainer>
                        <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                        {this.renderDataTable(this.prepareColumns())}
                    </Card>
                </BlockUi>
            </DivContainer>
        );
    }
}

BaseListContainer.defaultProps = {
    roles: '',
    selectionMode: 'multiple',
    hideFilters: false,
};

BaseListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    roles: PropTypes.string,
    hideFilters: PropTypes.bool,
   // customDatatableRowStyle: PropTypes.func,
};

export default BaseListContainer;
